import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CraftRoleList } from '@tailoring-crm/shared';
import { useApiClient } from '../api/api-context.js';
import { getCraftRoles } from './craft-roles-api.js';

/**
 * The shop's craft-role list, for the roster filter and the profile picker.
 *
 * Its own query key rather than a slice of the staff one: the list changes when the shop edits
 * its settings, not when somebody is hired, and invalidating the roster should not re-fetch it.
 */
export const craftRoleKeys = {
  all: ['craft-roles'] as const,
  list: () => ['craft-roles', 'list'] as const,
};

export function useCraftRoles(): UseQueryResult<CraftRoleList> {
  const client = useApiClient();
  return useQuery({ queryKey: craftRoleKeys.list(), queryFn: () => getCraftRoles(client) });
}
